module.exports = __webpack_public_path__ + "img/rocket-icon.f67ed42a.svg";